import constConfig from "@/common/const";
import store from "../store";
import Cookies from "js-cookie";
import axios from "axios";
export default {
  data() {
    return {
      transitionList: [
        constConfig.VIEW_PASSWORD_EDIT,
        constConfig.VIEW_TOP,
        constConfig.VIEW_SEARCH_PLAN,
        constConfig.VIEW_CONSTRUCT_INPUT,
        constConfig.VIEW_PLAN_DETAIL,
        constConfig.VIEW_PLAN_COMPLETE,
        constConfig.VIEW_NOTICE,
        constConfig.VIEW_NOTICE_DETAIL,
        constConfig.VIEW_MAIL_ADDESS,
        constConfig.VIEW_SAVED_PLAN_LIST,
        constConfig.VIEW_SAVED_PLAN_DETAIL,
        constConfig.VIEW_FINANCING_PLAN,
        constConfig.VIEW_MEMBERSHIP_REGIST,
        constConfig.VIEW_CONTACT,
        constConfig.VIEW_DOCUMENT_OFFER,
        constConfig.VIEW_MOVING_QUOTATION,
        constConfig.VIEW_CONTRACT,
        constConfig.VIEW_PLAN_DELETE_COMPLETE,
        constConfig.VIEW_PLAN_UPDATE_COMPLETE,
        constConfig.VIEW_FINANCING_PLAN_IMAGE_DISP,
        constConfig.VIEW_SERVICE,
        constConfig.VIEW_BASIC_STRUCTURE,
        constConfig.VIEW_STANDARD_SPEC,
        constConfig.VIEW_COMPANY,
        constConfig.VIEW_TERMS,
        constConfig.VIEW_IMPROVE_GRUND,
        constConfig.VIEW_PRIVACY_POLICY,
        constConfig.VIEW_RESERVATION,
        constConfig.VIEW_SITE_POLICY,
        constConfig.VIEW_SNS_POLICY,
        constConfig.VIEW_PW_REISSUE,
        constConfig.VIEW_DOCUMENT_DOWNLOAD,
        constConfig.VIEW_DOCUMENT_UPLOAD,
        constConfig.VIEW_SCHEDULE,
        constConfig.VIEW_VIA_LOGIN,
        constConfig.VIEW_COMPLETEWITNESS,
        constConfig.VIEW_TRANSFER,
        constConfig.VIEW_LIV_PLAN,
        constConfig.VIEW_VARYS_LINEUP,
        constConfig.VIEW_VARYS_FLOOR,
        constConfig.VIEW_MAILAUTHKEY_EXPIRED,
        constConfig.VIEW_STANDARD_SPEC_VARYS,
        constConfig.VIEW_STORE_LIST
      ]
    };
  },
  methods: {
    /**
     * 画面情報を取得する。
     * @param info : 画面情報（router）
     * @return transitionInfo : 画面情報
     */
    getViewInfo: function(info) {
      var result = false;
      var transitionInfo = null;
      this.transitionList.forEach(tr => {
        if (tr.name == info.name) {
          result = true;
          transitionInfo = tr;
        }
      });
      if (result) {
        return transitionInfo;
      } else {
        return null;
      }
    },
    getViewInfoFromPath: function(path) {
      var result = false;
      var transitionInfo = null;
      this.transitionList.forEach(tr => {
        if (tr.path == path) {
          result = true;
          transitionInfo = tr;
        }
      });
      if (result) {
        return transitionInfo;
      } else {
        return null;
      }
    },
    addBreadCrumb: function(viewInfo, linkFlg) {
      return {
        name: viewInfo.name,
        link: linkFlg,
        query: viewInfo.query,
        params: viewInfo.params
      };
    },
    commonFileDownload: function(blob, fileName) {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: blob.type }));
        const linkEl = document.createElement("a");
        linkEl.href = url;
        linkEl.setAttribute("download", fileName);
        document.body.appendChild(linkEl);
        linkEl.click();
        setTimeout(() => {
          URL.revokeObjectURL(url);
          document.body.removeChild(linkEl);
        }, 200);
      }
    },
    commonOpenLoginModal: function(loginModal) {
      Cookies.remove("livnex_cookie_authKey");
      Cookies.remove("livnex_cookie_loginKeepFlg");
      store.commit("setLoggedIn", false);
      store.commit("setServerLogged", false);
      loginModal.open();
    },
    commonCancelLogin: function(router) {
      router.push({ name: "Top" });
    },
    commonCloseLoginModal: function(loginModal) {
      loginModal.close();
    },
    commonLoginSuccess: function(loginModal, router) {
      loginModal.close();
      router.go({
        name: router.currentRoute.name,
        force: true
      });
    },
    commonGoMailRegist: function(loginModal, router) {
      loginModal.close();
      router.push({ name: "MailAddress", force: true });
    },
    keepLoginSession: function() {
      // console.log("セッション保持するよ！");
      axios
        .post("/api/authentication/isLoggedIn")
        .then(res => {
          if (res.data.result == 1) {
            this.$store.commit("setServerLogged", false);
          } else {
            this.$store.commit("setServerLogged", true);
          }
        })
        .catch(() => {
          this.$router.push({ name: "Error" });
        });
    },
    // 別ウィンドウで開く
    openOtherWindow: function(windowName, params) {
      let resolvedRoute = this.$router.resolve({
        name: windowName,
        query: params
      });
      let newWin = window.open(
        resolvedRoute.href,
        windowName + "Window",
        "scrollbars=yes, status=no, toolbar=no, location=no, menubar=no, resizable=yes"
      );
      newWin.focus();
    },
    // ログイン画面遷移（replace）
    viaLogin: function(route) {
      // クッキー削除
      Cookies.remove("livnex_cookie_authKey");
      store.commit("setLoggedIn", false);
      store.commit("setServerLogged", false);
      let params = {};
      params.toName = route.name;
      if (route.query && route.query.simulationNo)
        params.simulationNo = route.query.simulationNo;
      if (route.query && route.query.contractNo)
        params.contractNo = route.query.simulationNo;
      this.$router.replace({
        name: "ViaLogin",
        params: params
      });
    },
    // リロード
    reload: function() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
    },
    // オプション変更時、初期化されるものがあるとアラートを表示
    optAlert: function(opt, selectedOptList) {
      if (opt.optionSecondaryCd == "057" && opt.optionTertiaryCd == "001") {
        // 「構造：基礎」変更時、ウッドデッキが初期値から変更のあった場合、モーダルを表示
        let selectedWooddeckCount = selectedOptList.filter(
          opt => opt.optionSecondaryCd == "027" && opt.bodyAmtIncTax != 0
        ).length;
        if (selectedWooddeckCount > 0) return "ウッドデッキ";
      } else if (
        opt.optionSecondaryCd == "039" &&
        opt.optionTertiaryCd == "000"
      ) {
        // 「薪ストーブ」変更時、太陽光パネルが初期値から変更のあった場合、モーダルを表示
        let selectSunPanelCount = selectedOptList.filter(
          opt =>
            opt.optionSecondaryCd == "035" &&
            opt.optionTertiaryCd == "001" &&
            opt.bodyAmtIncTax != 0
        ).length;
        if (selectSunPanelCount > 0) return "太陽光パネル";
      }
      return null;
    },
    // オプション小分類表示制御
    optTertiaryShow: function(opt, optionList) {
      if (opt.optionSecondaryCd == "057" && opt.optionTertiaryCd == "001") {
        if (opt.bodyAmtIncTax == 0) {
          optionList
            .filter(optGroup => optGroup.optionSecondaryCd == "027")
            .forEach(
              optGroup =>
                (optGroup.show = !["000", "002"].includes(
                  optGroup.optionTertiaryCd
                ))
            );
        } else {
          optionList
            .filter(optGroup => optGroup.optionSecondaryCd == "027")
            .forEach(
              optGroup =>
                (optGroup.show = ["000", "002"].includes(
                  optGroup.optionTertiaryCd
                ))
            );
        }
      }
    },
    optFindIndex: function(opt, searchWord) {
      if (opt.itemName.indexOf(searchWord) == -1) return false;
      return true;
    }
  }
};
